import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { Activity } from './Activity';

/** A trip's history: who changed what and when, and who has it open now. */
export function History() {
  const { t } = useTranslation();
  const { id = '' } = useParams();
  return (
    <div className="history-page">
      <h1 className="visually-hidden">{t('history.title')}</h1>
      <Activity trip={id} />
    </div>
  );
}
